import React from "react";
import { useGlobalContext } from "../../providers/context";

const NavbarWelcomeMessage = () => {
  const { stateGlobal } = useGlobalContext();

  return (
    <>
      <li>
        <span className="m-r-sm welcome-message">
          Bem vindo(a) {stateGlobal.usuario.nome}.
        </span>
      </li>
    </>
  );
};

export default NavbarWelcomeMessage;
